import React from "react";
import { _LandingAboutWithFooterPetitPrinceRoot } from "./LandingAboutWithFooterPetitPrince.styled";
import AboutPetitPrince, {
  IAboutPetitPrinceProps,
} from "./AboutPetitPrince/AboutPetitPrince";
import FooterPetitPrince, {
  IFooterPetitPrinceProps,
} from "./FooterPetitPrince/FooterPetitPrince";
import StyledDiv from "../../StyledDiv/StyledDiv";
import DecorationBase from "./Decorations/DecorationBase/DecorationBase";

interface ILandingAboutWithFooterPetitPrinceProps {
  aboutProps: IAboutPetitPrinceProps;
  footerProps: IFooterPetitPrinceProps;
}

const LandingAboutWithFooterPetitPrince = (
  props: ILandingAboutWithFooterPetitPrinceProps
) => {
  const { aboutProps, footerProps } = props;

  return (
    <_LandingAboutWithFooterPetitPrinceRoot>
      <StyledDiv
        as="div"
        styles={{
          position: "relative",
          zIndex: 2,
        }}
        className="landing-about-with-footer-petit-prince__container"
      >
        <AboutPetitPrince {...aboutProps} />
        <StyledDiv
          styles={{
            padding: 0,
            height: "68px",
            mobile: {
              height: "0px",
            },
          }}
        ></StyledDiv>
        <FooterPetitPrince {...footerProps} />
      </StyledDiv>
      <DecorationBase
        styles={{
          position: "absolute",
          zIndex: 1,
          bottom: 0,
          right: 0,
          transform: "translate(21%, 8%)",
          mobile: {
            transform: "translate(0%, 0%)",
            scale: " 0.7",
            bottom: "-15%",
            right: "-53%",
          },
        }}
      />
    </_LandingAboutWithFooterPetitPrinceRoot>
  );
};

export default LandingAboutWithFooterPetitPrince;
